// 2023.05 TOPリニューアル	に伴い一時削除
// /* メインビジュアルポップアップ
// -------------------------------------------------- */
// var movie_start = function(){
// 	var player = new Vimeo.Player($('#vimeo_movie'));
// 	$('.js_popupOpen').click(function(){
// 		var dname = $(this).attr('data-popupName');
// 		$('.'+dname).addClass('open');
// 		player.play();
// 		if(!$('.popupBgi').length){$('.popup').append('<div class="popupBgi"></div>');}
// 		$('.popupBgi,.popupClose').click(function(){
// 			$('.popup').removeClass('open');
// 			player.pause();
// 		})
// 	})
// };
// movie_start();

// /* メイン スライダー設定（Swiper.js）
// -------------------------------------------------- */
// // Swiper用 ウィンドウ横幅サイズ取得
// var scaleWindowW = function() {
// 	var $w = $(window).width();
// 	return $w;
// };
// 
// $(function(){
// 	var swiperSetting = undefined; // Swiperの設定状況
// 	var swiperEl = '.mainSliderContainer';
// 	var $swiperWrapper = $(swiperEl + ' .swiper-wrapper');
// 	var $swiperSlide = $(swiperEl + ' .swiper-slide');
// 
// 	var initSwiper = function() {
// 		// 640px超える場合かつSwiperが設定されていない場合
// 		if (scaleWindowW() > 640 && swiperSetting == undefined) {
// 			swiperSetting = new Swiper(swiperEl, {
// 				loop: true,
// 				slidesPerView: 'auto',
// 				speed: 1000,
// 				autoplay: {
// 					delay: 5000,
// 					disableOnInteraction: false
// 				},
// 				navigation: {
// 					nextEl: '.swiper-button-next',
// 					prevEl: '.swiper-button-prev',
// 				},
// 			});
// 			swiperSetting.autoplay.stop(); // ファーストビューが消えてから動かすため、一旦停止
// 
// 		// 640px以下かつSwiperが未設定でない場合
// 		} else if (scaleWindowW() <= 640 && swiperSetting != undefined) {
// 			swiperSetting.destroy(); // Swiper破壊
// 			swiperSetting = undefined;
// 			for ( var i = 0; i < $swiperWrapper.length; i++ ) {
// 				$swiperWrapper[i].removeAttribute('style'); // wrapperのstyle属性を削除
// 			}
// 			for ( var i =0; i < $swiperSlide.length; i++ ) {
// 				$swiperSlide[i].removeAttribute('style'); // slideのstyle属性を削除
// 			}
// 		}
// 	}
// 
// 	initSwiper();
// 	window.addEventListener('resize',initSwiper);
// 
// 	// ファーストビュー ロジック
// 	var fistviewStatus = null; // ファーストビュー状態
// 	var firstviewFunc = function() {
// 		const $sliderEl = $('.mainSliderContainer');
// 		if(scaleWindowW() > 640 && fistviewStatus == null){ // PCかつスライダー未起動の場合
//		// ファーストビューのテキストのアニメーションが終わったら
// 			$(".firstviewPanel .leadText").on('animationend webkitAnimationEnd',function(){ 
// 				if(!$sliderEl.hasClass('visible')){
// 					$sliderEl.addClass('visible');
// 				}
// 				setTimeout(function() {
// 					$('.firstviewPanel').fadeOut(1400).queue(function() {
// 						swiperSetting.autoplay.start();
// 					});
// 				}, 2000);
// 			});
// 			fistviewStatus = 'start';
// 		} else if (scaleWindowW() > 640 && fistviewStatus != null){ // PCかつスライダー起動済みの場合（SP→PCなど）
// 			$('.firstviewPanel').css('display','none');
// 			swiperSetting.autoplay.start();
// 		} else {
// 			if(!$sliderEl.hasClass('visible')){
// 				$sliderEl.addClass('visible');
// 			}
// 			$('.firstviewPanel').removeAttr('style');
// 			fistviewStatus = 'start';
// 		}
// 	}
// 	firstviewFunc();
// 	window.addEventListener('resize',firstviewFunc);
// 
// }, false);
// 
// // 黄色リードエリア ロジック
// $(window).on('load resize', function(){
// 	if(scaleWindowW() > 640){
// 		$(".subLead").insertAfter("#mainSlider");
// 	}else{
// 		$(".subLead").insertAfter(".firstviewPanel");
// 	}
// });

/* PickUp バナー もっと見る
-------------------------------------------------- */
$(function(){
	var $accordion = $('#js-pickup-accordion');
	$('#js-btnPickup').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$(this).text('さらに表示する');
			$accordion.slideUp(300);
		}else{
			$(this).addClass('open');
			$accordion.slideDown(300);
			$(this).text('閉じる');
		}
	});
});

/* infolistのスクロールバーstyle変更
-------------------------------------------------- */
$(window).on('load resize', function(){
	var w = window.outerWidth;
	if(w > 640){
		var ps = new PerfectScrollbar('#infoList', { // eslint-disable-line
			maxScrollbarLength: 75
		});
	}
});

/* 公開講座 リスト
-------------------------------------------------- */
$(function () {
	var eventList = '#home #listOpenClass #js-openclass-count';
	var itemCount = $(eventList + ' li').length;
	//講座が1個の場合は.oddを付与する
	if (itemCount == 1) {
		$(eventList).addClass('odd');
	}
});

/* イベント リスト
-------------------------------------------------- */
$(function() {
	var eventList = '#home #listEvent #js-event-count';
	var itemCount = $(eventList + ' li').length;
	//イベントが1個の場合は.oddを付与する
	if ( itemCount == 1 ) {
		$(eventList).addClass('odd');
	}
});

/* 文字数制限を行う場合下記の関数を使う 例：textCut('#home #pager_slider_mainvisual-label .title','28','…');
-------------------------------------------------- */
$(function(){
	function textCut($setElm,$textCut,$textAfter) { // eslint-disable-line
		var $setElm = $($setElm); // eslint-disable-line
		$setElm.each(function(){
			var textLength = $(this).text().length;
			var textTrim = $(this).text().substr(0,($textCut)); // eslint-disable-line

			if($textCut < textLength) { // eslint-disable-line
					$(this).html(textTrim + $textAfter).css({visibility:'visible'});
			} else if($textCut >= textLength) {
					$(this).css({visibility:'visible'});
			}
		});
	}
});

//inview制御
function animeType(className) {
	$('.js-' + className).on('inview', function (event, isInView) {
		if (isInView) {
			$(this).stop().addClass('animation');
		}
	});
}
animeType('fadein-up');

/*   POPUP
-------------------------------------------------- */
	$('#home .js_popupOpen').magnificPopup({
		type: 'inline',
		preloader: false,
		fixedContentPos: true,
		closeOnBgClick: true
	});

/*   アコーディオン
-------------------------------------------------- */
$('.js-accordion').next().hide(); // 初期状態を非表示に
$('.js-accordion').on('click',function(){
	$(this).toggleClass('open');
	$(this).next().slideToggle(100);
})

/*   タブ絞り込み
-------------------------------------------------- */
function tabFunc($idname) {
	$($idname+' .tab_item').on('click', function() {
	  var tab_num = $(this).parent().index();
	  $($idname+' .tab_item').removeClass("active");
	  $($idname).siblings().children('.tab_item').removeClass("active");
	  if(tab_num == 0) {
	  	$(this).addClass("active");
			$($idname).siblings().children('.tab_item').addClass("active");
	  } else {
	  	$(this).addClass("active");
	  	$($idname).siblings().children('.tab_item:nth-child('+tab_num+')').addClass("active");
	  }
	});
}
tabFunc('#js_tab_nav');
tabFunc('#js_tab_nav2');


/*   セレクト絞り込み
-------------------------------------------------- */
function selectFunc($idname) {
$($idname).on('change',function(){
	  var tab_num = $($idname).prop("selectedIndex"); //選択されたoptionのindexを取得
	  var tab_name = $($idname+' option:selected').text(); //選択されたoptionのindexを取得
		$($idname).siblings().children('.refineLabel').text(tab_name); //ラベルの名前を変更
	  $($idname).parents().siblings().children('.tab_item').removeClass("active"); //全てのtabContentsを非表示
	  
	  if(tab_num == 0) {
			$($idname).parents().siblings().children('.tab_item').addClass("active"); //「すべて」が選択された場合、全てのtabContentsを表示
	  } else {
	  	$($idname).parents().siblings().children('.tab_item:nth-child('+tab_num+')').addClass("active"); //「すべて」以外が選択された場合、選択されたindexと同等のtabContentsを表示
	  }
});
}
selectFunc('#js_select_nav');
selectFunc('#js_select_nav2');

